export default "__VITE_ASSET__CQj8WpHL__"